$(document).ready(function() {
    $('.accordion').on('click', function() {
        // Remove open attribute from all other accordions
        $('.accordion').not(this).removeAttr('open');
    });
});


